import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import {
  getResultsTableData
} from 'selectors';

import Table from 'components/table/Table';
import DefaultCell from 'app/meets/board/cells/DefaultCell';
import NameCell from './cells/NameCell';
import TeamCell from './cells/TeamCell';
import PlaceCell from './cells/PlaceCell';
import AttemptCell from './cells/AttemptCell';
import ScoreCell from './cells/ScoreCell';
import CheckIcon from 'icons/CheckIcon';

import {
  getBenchLabel
} from 'util/meetHelper';

class DivisionResultsTable extends Component {
  state = { showModal: false }

  getAllColumns = () => {
    return [
      {key: 'name', label: 'Name', width: 175, renderer: NameCell},
      {key: 'team', label: 'Team', width: 115, renderer: TeamCell},
      {key: 'place', label: 'Place', width: 55, renderer: PlaceCell},
      {key: 'bodyWeight', label: 'Body Wgt', width: 75, renderer: DefaultCell},
      {key: 'weight', label: 'Squat 1', width: 70, lift: 'squat', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 2', width: 70, lift: 'squat', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Squat 3', width: 70, lift: 'squat', attemptNumber: '3', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 1`, width: 70, lift: 'bench', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 2`, width: 70, lift: 'bench', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: `${getBenchLabel(this.props.meet)} 3`, width: 70, lift: 'bench', attemptNumber: '3', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 1', width: 70, lift: 'dead', attemptNumber: '1', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 2', width: 70, lift: 'dead', attemptNumber: '2', renderer: AttemptCell},
      {key: 'weight', label: 'Dead 3', width: 70, lift: 'dead', attemptNumber: '3', renderer: AttemptCell},
      {key: 'score', width: 110, renderer: ScoreCell}
    ];
  }

  getCellLines = (index) => {
    return 1;
  }

  render() {

    const {
      data,
      setForecasted,
      forecasted,
      divisions
    } = this.props;

    const division = _.first(divisions);
    const weightClass = _.get(division, ['weightClasses', 0]);

    const dataWithDivisionInHeader = _.map(data, (row) => {
      if(row && row.row === 'header') {
        return {...row, division: division};
      }

      return row;
    });
    const dataWithTitleRowRemoved = _.reject(dataWithDivisionInHeader, (row) => row && row.row === 'title');

    const columns = this.getAllColumns();

    return (
      <div style={{height: '100%'}}>
        <div className="util-row">
          <button className="forecasted" onClick={() => setForecasted()}>
              Forecasted&nbsp;{ forecasted && <CheckIcon />}
          </button>
        </div>
        <div className="division-title">{_.get(division, 'name')} - {_.get(weightClass, 'name')}</div>
        <div className="table-wrapper">
          <Table
            data={dataWithTitleRowRemoved}
            numberOfFixedLeftColumns={0}
            columns={columns}
            getCellLines={this.getCellLines}
            meet={this.props.meet}
            scrollToAlignment='center'
            media={this.props.media}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    data: getResultsTableData(state, props)
  };
};

const actions = {};

export default withRouter(connect(mapStateToProps, actions)(DivisionResultsTable));
